import { LexicalNode } from 'lexical';
import {
  $createReferenceCitationSeparatorNode,
  $isReferenceCitationSeparatorNode,
  ReferenceCitationSeparatorNode,
} from 'modules/Lexical/nodes/ReferenceCitationSeparatorNode';
import { $copyStylesFromNeighbours } from '../../../helpers/copyStylesFromNeighbours';
import { $isReferenceCitationNode, ReferenceCitationNode } from '../../../nodes/ReferenceCitationNode';

function $isReferenceRelatedNode(
  node: LexicalNode | null,
): node is ReferenceCitationNode | ReferenceCitationSeparatorNode {
  return $isReferenceCitationNode(node) || $isReferenceCitationSeparatorNode(node);
}

function $insertAfterIfNeeded(
  refNode: ReferenceCitationNode | ReferenceCitationSeparatorNode,
  nodeToInsert: ReferenceCitationNode | ReferenceCitationSeparatorNode,
): void {
  if (nodeToInsert.getPreviousSibling() !== refNode) {
    refNode.insertAfter(nodeToInsert);
  }
}

export function $reorderNodes(
  startNode: ReferenceCitationNode,
  numbersMap: Record<string, number>,
): void {
  const references: ReferenceCitationNode[] = [startNode];
  const separators: ReferenceCitationSeparatorNode[] = [];

  let prev = startNode.getPreviousSibling();
  while ($isReferenceRelatedNode(prev)) {
    if ($isReferenceCitationNode(prev)) {
      references.unshift(prev);
    } else {
      separators.unshift(prev);
    }
    prev = prev.getPreviousSibling();
  }

  let next = startNode.getNextSibling();
  while ($isReferenceRelatedNode(next)) {
    if ($isReferenceCitationNode(next)) {
      references.push(next);
    } else {
      separators.push(next);
    }
    next = next.getNextSibling();
  }

  if (references.length === 1) {
    separators.forEach(node => node.remove());

    return;
  }

  const getNumber = (node: ReferenceCitationNode): number => numbersMap[node.getReferenceId()] ?? Infinity;
  references.sort((a, b) => getNumber(a) - getNumber(b));

  let current = references[0];
  references.slice(1).forEach((node) => {
    let separator = separators.shift();
    if (separator) {
      $insertAfterIfNeeded(current, separator);
    } else {
      separator = $createReferenceCitationSeparatorNode();
      current.insertAfter(separator);
      $copyStylesFromNeighbours(separator);
    }
    $insertAfterIfNeeded(separator, node);
    current = node;
  });
  separators.forEach(node => node.remove());
}
